// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MailFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m.751 1.899 8.598 7.51a1.75 1.75 0 0 0 2.302 0l8.598-7.51c.081.191.126.401.126.622v10.958c0 .88-.716 1.596-1.595 1.596H2.22c-.88 0-1.595-.716-1.595-1.596V2.521c0-.22.045-.43.126-.622Zm.66-.752c.237-.14.514-.222.81-.222H18.78c.295 0 .572.081.81.222l-8.597 7.508a.75.75 0 0 1-.986 0L1.41 1.147Z"
			fill="#1DA1F2"
		/>
	</svg>
);
export default MailFilled;
